import React, { Component, createRef } from 'react'
import get from 'lodash/get'
import { List, Map } from 'immutable'
import { get as getConfig } from 'config'
import { getBoundActions } from 'actions'
import Link, { TextLink } from 'components/Link'
import { connect as connectRedux } from 'react-redux'
import Sherpa, { TYPE_LARGE } from 'components/Sherpa'
import NotificationsWatchNow from 'components/NotificationsWatchNow'
import { NotificationsBell, BELL_TYPES } from 'components/NotificationsBell'
import { NotificationsFollowButton, BUTTON_TYPES } from 'components/NotificationsFollowButton'
import NotificationsVideoPromotion from 'components/NotificationsVideoPromotion'
import ToolTipArrow, { DIRECTION_UP } from 'components/ToolTipArrow'
import { NOTIFICATION_TYPES, SUBSCRIPTION_TYPES } from 'services/notifications'
import { HASHTAG_FOLLOW_SETTINGS, URL_ACCOUNT_SETTINGS } from 'services/url/constants'
import {
  NAVIGATION_EVENT_LABELS,
  PLAY_CLICK_GA4_EVENT,
  NOTIFICATIONS_OPENED_GA4_EVENT,
  NOTIFICATIONS_MANAGE_CLICKED_GA4_EVENT,
  NOTIFICATIONS_VIEW_ALL_CLICKED_GA4_EVENT,
  CLICK_TO_DETAILS_PAGE_GA4_EVENT,
} from 'services/event-tracking'
import { dateIsFuture } from 'services/date-time'

const EMPTY_LIST = List()
const EMPTY_MAP = Map()

const config = getConfig()

function getGa4EventData (notification) {
  // GA4 events
  const series = notification.getIn(['node', 'series'], Map())

  let eventData = {
    notification_type: notification.get('type'),
    content_id: notification.get('contentId'),
    content_name: notification.getIn(['node', 'title']),
    content_type: notification.get('contentType'),
    media_id: notification.getIn(['node', 'feature', 'nid']),
    media_language: notification.getIn(['node', 'language']),
    is_featured_media: true,
    ui_element: 'Notification',
    ui_location: 'Notifications Menu',
  }
  if (Map.isMap(series) && series.size > 0) {
    eventData = {
      ...eventData,
      parent_series_name: series.get('title'),
      parent_series_id: series.get('nid'),
    }
  }

  return eventData
}

function renderFreeForm (notification) {
  const id = notification.get('id')
  const imgUrl = notification.getIn(['node', 'keyart_16x9_withtext', 'keyart_304x171'], '')
  const title = notification.getIn(['node', 'title'], '')
  const reason = notification.get('reason')
  const links = notification.get('links', List())
  const webLink = links.find((link) => link.get('type') === 'WEB')
  const webTarget = webLink && webLink.get('external') ? '_blank' : '_self'
  const message = notification.get('message')

  // GA4 events
  const ga4EventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep(
    getGa4EventData(notification),
  )

  return (
    <li
      key={id}
      className="notifications-menu__item"
    >
      <div className={`notifications-menu__item-left${imgUrl ? '' : ' has-bell'}`}>
        {imgUrl ? (
          <div className="notifications-menu__item-hero">
            <img
              className="notifications-menu__item-img"
              src={imgUrl}
              alt={title}
            />
          </div>
        ) : null }
        {imgUrl ? (
          <span className="notifications-menu__item-date">
            {notification.get('timeAsDistance', '')}
          </span>
        ) : null}
      </div>
      <div className={imgUrl ? 'notifications-menu__item-right' : 'notifications-menu__item-freeform'}>
        {imgUrl ? (
          <div className="notifications-menu__item-context">
            {reason}
          </div>
        ) : null}
        <p className="notifications-menu__item-freetext">
          {webLink ? (
            <TextLink
              data-id={id}
              to={webLink.get('path')}
              target={webTarget}
              text={message}
              ga4EventData={ga4EventData}
            />
          ) : message }
        </p>
        {!imgUrl ? (
          <span className="notifications-menu__item-date">
            {notification.get('timeAsDistance', '')}
          </span>
        ) : null}
      </div>
    </li>
  )
}

function renderRecommendation (notification, onClick) {
  const imgUrl = notification.getIn(['node', 'keyart_16x9_withtext', 'keyart_304x171'], '')
  const path = notification.getIn(['node', 'path'], '')
  const title = notification.getIn(['node', 'title'], '')
  const type = notification.getIn(['node', 'type'])
  const id = notification.get('id')

  // GA4 events
  const ga4EventData = getGa4EventData(notification)
  const ga4PlayClickEventData = PLAY_CLICK_GA4_EVENT.mergeDeep(ga4EventData)
  const ga4ClickToDetailsEventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep(ga4EventData)

  return (
    <li key={id} className="notifications-menu__item">
      <div className="notifications-menu__item-left">
        <div className="notifications-menu__item-hero">
          <img
            className="notifications-menu__item-img"
            src={imgUrl}
            alt={title}
          />
        </div>
        <span className="notifications-menu__item-date">
          {notification.get('timeAsDistance', '')}
        </span>
      </div>
      <div className="notifications-menu__item-right">
        <div className="notifications-menu__item-context">
          {notification.get('label', '')}
        </div>
        <div className="notifications-menu__item-message">
          <TextLink
            to={path}
            onClick={onClick}
            data-id={id}
            text={title}
            ga4EventData={ga4ClickToDetailsEventData}
          />
        </div>
        {type === 'product_series' ? (
          <NotificationsFollowButton
            type={BUTTON_TYPES.PRIMARY_SMALL}
            contentId={notification.get('contentId')}
            subscriptionType={SUBSCRIPTION_TYPES.SERIES}
            uiLocation={'Notification Menu'}
          />
        ) : null}
        {type !== 'product_series' ? (
          <Link
            className="notifications-menu__item-watch"
            to={`${path}?fullplayer=feature`}
            data-id={id}
            onClick={onClick}
            ga4EventData={ga4PlayClickEventData}
          >
            <NotificationsWatchNow />
          </Link>
        ) : null}
      </div>
    </li>
  )
}

function renderNewEpisode (notification, onClick) {
  const seriesPath = notification.getIn(['node', 'series', 'path'], '')
  const imgUrl = notification.getIn(['node', 'keyart_16x9_withtext', 'keyart_304x171'], '')
  const path = notification.getIn(['node', 'path'], '')
  const title = notification.getIn(['node', 'title'], '')
  const id = notification.get('id')

  // GA4 events
  const ga4EventData = getGa4EventData(notification)
  const ga4PlayClickEventData = PLAY_CLICK_GA4_EVENT.mergeDeep(ga4EventData)
  const ga4ClickToDetailsEventData = CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep(ga4EventData)

  return (
    <li key={id} className="notifications-menu__item">
      <div className="notifications-menu__item-left">
        <div className="notifications-menu__item-hero">
          <img
            className="notifications-menu__item-img"
            alt={title}
            src={imgUrl}
          />
        </div>
        <div className="notifications-menu__item-date">
          {notification.get('timeAsDistance', '')}
        </div>
      </div>
      <div className="notifications-menu__item-right">
        <div className="notifications-menu__item-label">
          {notification.get('label', '')}
        </div>
        <div className="notifications-menu__item-context">
          <TextLink
            text={notification.getIn(['node', 'series', 'title'], '')}
            to={seriesPath}
            onClick={onClick}
            data-id={id}
            ga4EventData={ga4ClickToDetailsEventData}
          />
        </div>
        <div className="notifications-menu__item-message">
          <TextLink
            to={path}
            onClick={onClick}
            data-id={id}
            text={title}
            ga4EventData={ga4ClickToDetailsEventData}
          />
        </div>
        <Link
          onClick={onClick}
          data-id={id}
          className="notifications-menu__item-watch"
          to={`${path}?fullplayer=feature`}
          ga4EventData={ga4PlayClickEventData}
        >
          <NotificationsWatchNow />
        </Link>
      </div>
    </li>
  )
}

function renderFollow (notification, onClick) {
  const imgUrl = notification.getIn(['member', 'image'], '')
  const title = notification.getIn(['member', 'title'], '')
  const url = notification.getIn(['member', 'url'], '')
  const id = notification.get('id')

  return (
    <li key={id} className="notifications-menu__item notifications-menu__item--member">
      <div className="notifications-menu__item-left">
        <div className="notifications-menu__item-hero">
          <img
            className="notifications-menu__item-img"
            alt={''} // title
            src={imgUrl}
          />
        </div>
      </div>
      <div className="notifications-menu__item-right">
        <div className="notifications-menu__item-label">
          {notification.get('label', '')}
        </div>
        <div className="notifications-menu__item-message">
          {url ? (
            <TextLink
              to={url}
              onClick={onClick}
              text={title}
              data-id={id}
            />
          ) : (
            <span>{title}</span>
          )}
        </div>
        <aside className="notifications-menu__item-date">
          {notification.get('timeAsDistance', '')}
        </aside>
      </div>
    </li>
  )
}

function renderNotifications (notifications = List(), onClick) {
  return notifications.map((n = Map()) => {
    switch (n.get('type')) {
      case NOTIFICATION_TYPES.MEMBER_FOLLOWING:
      case NOTIFICATION_TYPES.ACCOUNT_FOLLOWED:
        return renderFollow(n, onClick)
      case NOTIFICATION_TYPES.SUBSCRIPTION_NEW_EPISODE:
      case NOTIFICATION_TYPES.SUBSCRIPTION_NEW_SEASON:
        return renderNewEpisode(n, onClick)
      case NOTIFICATION_TYPES.MEMBER_RECOMMENDATION:
      case NOTIFICATION_TYPES.GENERAL_RECOMMENDATION:
      case NOTIFICATION_TYPES.SUBSCRIPTION_RECOMMENDATION:
        return renderRecommendation(n, onClick)
      case NOTIFICATION_TYPES.MEMBER_FREE_FORM:
      case NOTIFICATION_TYPES.GENERAL_FREE_FORM:
      case NOTIFICATION_TYPES.GENERAL_NEW_FEATURE:
      case NOTIFICATION_TYPES.SUBSCRIPTION_FREE_FORM:
        return renderFreeForm(n, onClick)
      default:
        return null
    }
  })
}

class NotificationsMenu extends Component {
  constructor (props) {
    super(props)
    this.containerRef = createRef()
  }

  componentDidMount () {
    const { props, handleClickOutside } = this
    const { getRecentNotifications } = props
    getRecentNotifications()
    document.addEventListener('mousedown', handleClickOutside)
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const {
      uid,
      language,
      getRecentNotifications,
    } = props
    const {
      uid: prevUid,
      language: prevLanguage,
    } = prevProps

    if (uid !== prevUid || language !== prevLanguage) {
      getRecentNotifications()
    }
  }

  componentWillUnmount () {
    const { handleClickOutside } = this
    document.removeEventListener('mousedown', handleClickOutside)
  }

  handleClickOutside = (event) => {
    const { props, containerRef, toggleMenu } = this
    const { visible } = props
    if (visible && containerRef.current && !containerRef.current.contains(event.target)) {
      toggleMenu(event)
    }
  }

  getUnseen () {
    const { props } = this
    const { recent } = props
    return recent.filter((n) => (
      n.get('received') !== true && n.get('type') !== NOTIFICATION_TYPES.GENERAL_VIDEO_PROMOTION
    ))
  }

  toggleMenu = (e) => {
    e.preventDefault()
    const { props } = this
    const {
      toggleNotificationsMenuVisible,
      setNavigationOverlayVisible,
      setNotificationsReceived,
      setNavigationClickEvent,
      setUserMenuVisible,
    } = props

    setNavigationClickEvent(NAVIGATION_EVENT_LABELS.NOTIFICATIONS, 'bell icon')
    const unseen = this.getUnseen()
    const ids = unseen.map((n) => n.get('id')).toJS()
    const impressed = unseen.map((n) => {
      return Map({
        id: n.get('id'),
        name: n.get('name'),
      })
    })

    setNotificationsReceived({ ids, impressed })
    toggleNotificationsMenuVisible()
    setNavigationOverlayVisible(false)
    setUserMenuVisible(false)
  }

  closeMenu = () => {
    const { props } = this
    const { toggleNotificationsMenuVisible } = props
    toggleNotificationsMenuVisible()
  }

  goToActivityDetails = () => {
    const { closeMenu } = this
    closeMenu()
  }

  renderDropdownContent () {
    const {
      staticText, processing, recent,
    } = this.props

    if (processing) {
      return <Sherpa type={TYPE_LARGE} />
    }
    if (recent.isEmpty()) {
      return (
        <div className="notifications-menu__empty">
          {staticText.getIn(['data', 'youHaveNoNewNotifications'])}
        </div>
      )
    }
    return (
      <ul className="notifications-menu__list">
        {renderNotifications(recent, this.closeMenu)}
      </ul>
    )
  }

  renderViewAll (ga4EventData) {
    const { staticText, isWebView } = this.props
    const webViewQueryParam = isWebView ? '&webview=true' : ''
    return (
      <div className="cm1-notifications-menu__bottom">
        <TextLink
          className="cm1-notifications-menu__viewall"
          text={staticText.getIn(['data', 'viewAll'], '')}
          onClick={this.closeMenu}
          to={`/notifications?${webViewQueryParam}`}
          ga4EventData={ga4EventData}
        />
      </div>
    )
  }

  renderBell () {
    const { props: { color } } = this
    const unseen = this.getUnseen()
    const unseenCount = unseen.size
    const modifier = unseenCount ? ' ringing' : ''
    const fill = color || '#44576B' // lets override this in the new header instead of passing prop

    return (
      <span className={`notifications-menu__bell${modifier}`}>
        {unseenCount ? (
          <span className="notifications-menu__received" />
        ) : null}
        <NotificationsBell
          type={BELL_TYPES.STROKE_HEAVY}
          fill={fill}
          size={27}
        />
      </span>
    )
  }

  renderPromotion () {
    if (!get(config, ['features', 'notificationsVideoPromotion'])) {
      return null
    }

    const { recent } = this.props
    const videoPromo = recent.find((n) => {
      const endDate = n.get('endDate')
      const isPromotion = n.get('type') === NOTIFICATION_TYPES.GENERAL_VIDEO_PROMOTION
      const isExpired = endDate && !dateIsFuture(new Date(endDate))
      return n.get('received') !== true && isPromotion && !isExpired
    })
    return videoPromo ? <NotificationsVideoPromotion notification={videoPromo}/> : null
  }

  render () {
    const { props, toggleMenu, containerRef } = this
    const {
      visible,
      staticText,
      location,
    } = props
    const manageLink = `${URL_ACCOUNT_SETTINGS}${HASHTAG_FOLLOW_SETTINGS}`

    const ga4NotificationsOpenedEventData = NOTIFICATIONS_OPENED_GA4_EVENT
      .mergeDeep({
        current_location: location.pathname,
        page_path: '/notifications',
      })

    const ga4NotificationsManageClicked = NOTIFICATIONS_MANAGE_CLICKED_GA4_EVENT
      .mergeDeep({
        ui_element: 'Notification',
        ui_location: 'Bell Menu',
        current_location: location.pathname,
      })

    const ga4NotificationsViewAllClickedEventData = NOTIFICATIONS_VIEW_ALL_CLICKED_GA4_EVENT
      .mergeDeep({
        ui_element: 'Notification',
        current_location: location.pathname,
        page_path: '/notifications',
      })

    return (
      <div className="notifications-menu" ref={containerRef}>
        {this.renderPromotion()}
        <ToolTipArrow
          direction={DIRECTION_UP}
          activeArrow="notifications-bell-arrow"
        />
        <Link
          aria-controls="notifications-menu__popup"
          title="Click to view your notifications"
          className="notifications-menu__icon"
          onClick={toggleMenu}
          to="/notifications"
          role="button"
          aria-haspopup
          ga4EventData={ga4NotificationsOpenedEventData}
        >{this.renderBell()}
        </Link>
        <div className="notifications-menu__container">
          <div
            id="notifications-menu__popup"
            className="notifications-menu__dropdown"
            aria-expanded={visible}
          >
            <div className="notifications-menu__top">
              <span className="notifications-menu__title">
                {staticText.getIn(['data', 'notifications'], '')}
              </span>
              <TextLink
                onClick={this.closeMenu}
                text={staticText.getIn(['data', 'manage'], '')}
                className="notifications-menu__manage"
                to={manageLink}
                ga4EventData={ga4NotificationsManageClicked
                  .mergeDeep({ page_path: manageLink })}
              />
            </div>
            {visible ? (
              <section className="notifications-menu__main">
                {this.renderDropdownContent()}
              </section>
            ) : null}
            <div className="notifications-menu__bottom">
              <TextLink
                className="notifications-menu__viewall"
                text={staticText.getIn(['data', 'viewAll'], '')}
                onClick={this.closeMenu}
                to="/notifications"
                ga4EventData={ga4NotificationsViewAllClickedEventData}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connectRedux(
  (state) => ({
    uid: state.user.getIn(['data', 'uid']),
    visible: state.header.get('notificationsMenuVisible'),
    processing: state.notifications.getIn(['recent', 'processing']),
    recent: state.notifications.getIn(['recent', 'data'], EMPTY_LIST) || List(),
    language: state.user.getIn(['data', 'language', 0], get(config, 'appLang')),
    staticText: state.staticText.getIn(['data', 'notificationsMenu'], EMPTY_MAP),
    isWebView: state.app.get('isWebView', false),
    location: state.resolver.get('location'),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setUserMenuVisible: actions.header.setUserMenuVisible,
      setNavigationOverlayVisible: actions.header.setNavigationOverlayVisible,
      toggleNotificationsMenuVisible: actions.header.toggleNotificationsMenuVisible,
      setNotificationsReceived: actions.notifications.setNotificationsReceived,
      getRecentNotifications: actions.notifications.getRecentNotifications,
    }
  },
)(NotificationsMenu)
